import { DashboardModuleListItem } from '@domain-group/suit-theme'
import { generateRedirectUrl } from '@domain-group/javascript-utils'

import type { ProviderPriceListModel } from '@models/types'

import useProviderPriceList from '@hooks/useProviderPriceList'

interface ProviderPriceListListItemProps {
  providerPriceList: ProviderPriceListModel,
}

const ProviderPriceList = (props: ProviderPriceListListItemProps) => {
  const {
    providerPriceList,
    providerPriceList: {
      id,
      master_price_list_version,
      title,
    },
  } = props

  const providerPriceListPayload = useProviderPriceList(providerPriceList)
  const {
    urls: {
      editProviderPriceListUrl,
    },
    isSyncedWithMaster,
  } = providerPriceListPayload

  return (
    <DashboardModuleListItem
      secondaryText={
        `Version ${master_price_list_version} - ${isSyncedWithMaster ? 'In Sync' : 'Needs Sync'}`
      }
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editProviderPriceListUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default ProviderPriceList
